// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2zO-m","footer":"ReportModalFilter_footer__1OCcW"};